// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e0b5eeaf","455":"15f424f6"}[chunkId] + ".chunk.js";
};